<template>
  <div v-if="popUpActive" class="lv-popup-preview" :class="{ active: popUpActive }">
    <div class="lv-popup-preview__name">
      <img :src="$_setFileIconFromUrl(url)" alt="" class="lv-popup-preview__name-img" />
      <LvText h3 bold white class="ml-8">{{ name }}</LvText>
    </div>
    <i
      class="icon-cloud-download lv-popup-preview__icon lv-popup-preview__download-btn"
      @click.stop="$_onDownload(url)"
    />
    <i
      class="icon-more lv-popup-preview__icon lv-popup-preview__more-btn"
      @click.stop="$_onClickMore()"
    />
    <div class="lv-popup-preview__container-wrap">
      <div class="lv-popup-preview__container">
        <div v-if="pdfFormat.has(fileType)" class="lv-popup-preview__pdf-wrap">
          <LvPdfViewer :key="url" :url="url" @download="$_onDownload" />
        </div>
        <img
          v-else-if="imgFormat.has(fileType)"
          :src="url"
          alt=""
          class="lv-popup-preview__container-img"
        />
        <div v-else-if="wordFormat.has(fileType)" class="lv-popup-preview__pdf-wrap">
          <LvDocxViewer :key="url" :url="url" @download="$_onDownload" />
        </div>
        <div v-else class="lv-popup-preview__no-preview">
          <LvText h3 bold>{{ $t('此檔案無法預覽') }}</LvText>
          <a download class="lv-popup-preview__download-link">
            <WsButton001 leading-icon="icon-cloud-download" @click="$_onDownload(url)">
              {{ $t('下載檔案') }}
            </WsButton001>
          </a>
        </div>
      </div>
    </div>
    <div class="lv-popup-preview_bg" @click.stop="$_onClose()" />
  </div>
</template>
<script>
import S_file from '@/service/api/v1/file';
import H_file from '@/helpers/file';
import Spare_file from '@/spare/file';
import Spare_filePhotos from '@/spare/file-photos';

export default {
  props: {
    url: {
      type: String,
    },
    showMoreBtn: {
      type: Boolean,
      default: true,
    },
    popUpActive: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
    },
    fileType: {
      type: String,
    },
    versionNumber: {
      type: [String, Number],
    },
  },
  data() {
    return {
      imgFormat: new Map(Spare_file.imageExtensionsWithoutDot.map(extension => [extension, true])),
      pdfFormat: new Map(Spare_file.pdfExtensionsWithoutDot.map(extension => [extension, true])),
      wordFormat: new Map(Spare_file.docxExtensionsWithoutDot.map(extension => [extension, true])),
      filePhotos: Spare_filePhotos.filePhotos,
    };
  },
  methods: {
    $_setFileIconFromUrl(url) {
      return H_file.setFileIconFromUrl(url);
    },
    $_onClose() {
      this.$emit('click');
    },
    async $_onDownload(url) {
      if (!url || !this.name || !this.fileType) {
        this.$store.dispatch('downloadPopup/open');
        this.$store.dispatch('downloadPopup/showError', '下載失敗，請稍後再試');
        return;
      }
      await S_file.download(url, this.name, this.fileType, this.versionNumber);
    },
    $_onClickMore() {
      this.$emit('go-to');
    },
  },
};
</script>
